// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602181533/js/" + chunkId + "." + {"44":"4907a8c4","225":"85a3bcfe","481":"816fa9fa","486":"4c5907b7","770":"179abc49"}[chunkId] + ".0.3910552170858299.chunk.js";
};